module.exports = __WEBPACK_EXTERNAL_MODULE_openfl_geom_Point__;